module.exports = __webpack_public_path__ + "static/media/contactsBlack.b44a2f2c.svg";